export default "__VITE_ASSET__CyO17lh5__"